export function getCurrentScriptBasePath() {
  const scriptEl = (document.currentScript as HTMLScriptElement) || findMatchingScript();
  return scriptEl ? scriptEl.src.replace('wm.integration.js', '') : null;
}

function findMatchingScript(): HTMLScriptElement | undefined {
  const scripts = [...document.getElementsByTagName('script')];
  return scripts.find((script) => !!(script.src && script.src.includes('wm.integration.js')));
}
